import { render, staticRenderFns } from "./drawer_see.vue?vue&type=template&id=23ffc374&scoped=true&"
import script from "./drawer_see.vue?vue&type=script&lang=js&"
export * from "./drawer_see.vue?vue&type=script&lang=js&"
import style0 from "./drawer_see.vue?vue&type=style&index=0&id=23ffc374&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ffc374",
  null
  
)

export default component.exports